//import $ from 'jquery';
import { getScrollbarWidth } from '../utils/helpers';

const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
let isOpen = false;
let xDown = null;
let yDown = null;
/**
 * Builds a HTML close button
 */
function buildCloseBtn() {
  const el = document.createElement('button');

  el.type = 'button';
  el.className = 'sm-modal--close-btn';
  el.innerHTML = '&times';
  el.setAttribute('aria-label', 'Close');
  el.addEventListener('click', () => {
    this.close();
  });

  return el;
}
/**
 * Returns the touch direction
 * @param {int} xUp x position when finger is lifted up or moved
 * @param {int} yUp y position when finger is lifted up or moved
 * @param {int} xDown x position when finger first touches the screen
 * @param {int} yDown y position when finger first touches the screen
 */
function getTouchDirection(xUp, yUp, xDown, yDown) {
  if (!xDown || !yDown) {
    return;
  }
  let touchDirection = '';

  const xDiff = xDown - xUp;
  const yDiff = yDown - yUp;

  if ( Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
    if (xDiff > 0) {
      /* left swipe */
      touchDirection = 'left';
    } else {
      /* right swipe */
      touchDirection = 'right';
    }
  } else {
    if (yDiff > 0) {
      /* up swipe */
      touchDirection = 'up';
    } else {
      /* down swipe */
      touchDirection = 'down';
    }
  }

  return touchDirection;
}
/**
 * Sets the outside-scoped xDown and yDown variables when the touchstart event occurs
 * @param {Object} e the touchstart event
 */
function handleTouchStart(e) {
  const firstTouch = e.touches[0];
  xDown = firstTouch.clientX;
  yDown = firstTouch.clientY;
}
/**
 * Callback function that runs when a touchmove event occurs. Stops all scrolling (only used on iOS) on elements except the popup
 * @param {Object} e the touchmove event
 */
function handleTouchMove(e) {
  const popup = document.querySelector('.sm-modal--active .sm-modal--content');

  if (popup === null) {
    return;
  }

  const height = popup.offsetHeight;
  const scroll = popup.scrollTop;
  const scrollHeight = popup.scrollHeight;
  const touchDirection = getTouchDirection(e.touches[0].clientX, e.touches[0].clientY, xDown, yDown);
  const popupPosition = popup.getBoundingClientRect();
  // console.dir(popup);
  // should not scroll anything besides the popup when it is active
  if ((!touchInPopup(e.touches[0], popupPosition)) || (scroll === 0 && touchDirection === 'down') || (scroll + height === scrollHeight && touchDirection === 'up')) {

    e.preventDefault();
  }
}
/**
 * Returns whether the touch was in the popup
 * @param {Object} touch touch property from the touchmove event
 * @param {Object} elPosition an object carrying the position of the popup
 */
function touchInPopup(touch, elPosition) {
  // console.dir(touch);
  // console.dir(elPosition);
  if (touch.clientX > elPosition.left && touch.clientX < elPosition.right && touch.clientY > elPosition.top && touch.clientY < elPosition.bottom) {
    // console.log('touch in popup');
    return true;
  }
  // console.log('touch not in popup');
  return false;
}
/**
 * Wraps content element in containers and appends the modal to the DOM
 */
function injectSleepyModal() {
  const wrapper = document.createElement('div');
  const background = document.createElement('div');
  const contentWrap = document.createElement('div');

  wrapper.className = this.options.class !== null ? 'sm-modal' + ' ' + this.options.class : 'sm-modal';
  background.className = 'sm-modal--background';
  contentWrap.className = 'sm-modal--content';

  wrapper.setAttribute('tabindex', '-1');
  wrapper.setAttribute('role', 'dialog');
  wrapper.setAttribute('aria-modal', true);
  wrapper.setAttribute('aria-hidden', true);
  if (this.options.closeBtn) {
    const closeBtn = buildCloseBtn.call(this);

    contentWrap.appendChild(closeBtn);
  }

  wrapper.appendChild(background);
  wrapper.appendChild(contentWrap);

  this.contentEl.parentNode.insertBefore(wrapper, this.contentEl);
  contentWrap.appendChild(this.contentEl);

  return wrapper;
}
/**
 * Callback fuction for the escape key press. Dispatches a event that the modal is listening for.
 * @param {Object} e the event object
 */
function documentCloseOnEscKeyHandler(e) {
  const smModal = document.querySelector('.sm-modal.sm-modal--active');

  if (!smModal) {
    return;
  }
  if (e.key === 'Escape' || e.key === 'Esc') {
    // TODO: below is deprecated, but the new way (Event object) does not work in IE. Maybe check for IE
    // this event also gets created everytime Esc is pressed. Do we need to create it one time only?
    const event = document.createEvent('Event');

    event.initEvent('sm-modal-esckeypress', false, false);
    smModal.dispatchEvent(event);
  }
}
/**
 * Records the focused element before the modal was opened
 */
function getFocusedElementBeforeOpen() {
  return document.activeElement;
}
class SleepyModal {
  constructor(el, options) {
    this.options = this.setOptions(options);
    this.contentEl = el instanceof HTMLElement ? el : document.querySelector(el);
    this.contentElOldParentEl = this.contentEl.parentNode;
    this.smModal = injectSleepyModal.call(this);
    this.smContent = this.smModal.querySelector('.sm-modal--content');
    this.focusedElementBeforeOpen = null;
  }
  /**
   * Overloads default options with user-defined ones.
   * @param {Object} userOptions Settings for the modal
   */
  setOptions(userOptions = {}) {
    let options = {
      closeOnBgClick: true,
      closeBtn: true,
      closeOnEsc: true,
      class: null,
      callbacks: {
        onopen: () => {},
        onclose: () => {}
      }
    };

    for (let key in userOptions) {
      if (options.hasOwnProperty(key)) {
        options[key] = userOptions[key];
      }
    }

    return options;
  }
  /**
   * Does necessary things to the modal to make it work
   */
  init() {
    this.addListeners();
  }
  /**
   * Add listeners based on the options that were set
   */
  addListeners() {
    // only apply these for iOS
    // if (iOS) {
    //   document.addEventListener('touchstart', handleTouchStart, { passive: false });
    //   document.addEventListener('touchmove', handleTouchMove, { passive: false });
    // }

    if (this.options.closeOnEsc) {
      document.addEventListener('keydown', documentCloseOnEscKeyHandler);
      this.smModal.addEventListener('sm-modal-esckeypress', () => {
        this.close();
      });
    }
    if (this.options.closeOnBgClick) {
      this.smModal.querySelector('.sm-modal--background').addEventListener('click', () => {
        this.close();
      });
    }
  }
  /**
   * Removes any listeners that were bound to the document object
   */
  removeListeners() {
    if (iOS) {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
    }
    if (this.options.closeOnEsc) {
      document.removeEventListener('keydown', documentCloseOnEscKeyHandler);
    }
  }
  /**
   * Opens the modal and calls the callback if there was one set
   */
  open() {
    if (isOpen) {
      return;
    }

    this.focusedElementBeforeOpen = getFocusedElementBeforeOpen();
    isOpen = true;
    this.smModal.className += ' sm-modal--active';
    document.documentElement.className += document.documentElement.className === '' ? 'sm-modal--active' : ' sm-modal--active';
    this.smModal.setAttribute('aria-hidden', false);
    this.smModal.focus();
    document.body.style.cssText += `
      padding-right: ${getScrollbarWidth()}px;
      overflow: hidden;
    `;
    if (typeof this.options.callbacks.onopen === 'function') {
      this.options.callbacks.onopen();
    }
  }
  /**
   * Closes the modal and calls the callback if there was one set
   */
  close() {
    if (!isOpen) {
      return;
    }

    isOpen = false;
    this.smModal.classList.remove('sm-modal--active');
    document.documentElement.classList.remove('sm-modal--active');
    this.smModal.setAttribute('aria-hidden', true);
    this.focusedElementBeforeOpen.focus();
    document.body.style.removeProperty('padding-right');
    document.body.style.removeProperty('overflow');

    if (typeof this.options.callbacks.onclose === 'function') {
      this.options.callbacks.onclose();
    }
  }
  /**
   * Returns Boolean if the modal is open or closed.
   */
  isOpen() {
    return isOpen;
  }
  /**
   * Destroy the modal. It removes all the bound listeners and returns the HTML to how it was before the modal was initialized.
   */
  destroy() {
    this.removeListeners();
    this.contentElOldParentEl.insertBefore(this.contentEl, this.smModal);
    this.contentElOldParentEl.removeChild(this.smModal);
  }
}
module.exports = SleepyModal;



// WEBPACK FOOTER //
// ./src/assets/js/classes/sleepy-modal.class.js